import React, { PureComponent } from 'react'
import { View } from 'react-native'
import styled from 'styled-components/native'

import ConnectionStatus from '../ConnectionStatus'

import theme from '../../../styles/theme'

const TopBar = styled(View)`
  flex-direction: row;
  padding: ${props => props.paddingMult * theme.gutterUnit}px;
  height: ${theme.headerHeight}px;
  background-color: ${props => props.colour};
  align-items: center;
`

export default class HeaderBar extends PureComponent {
  render () {
    const {
      children,

      black,
      transparent,

      paddingMult = 1
    } = this.props

    let colour = theme.colours.white

    if (black) {
      colour = theme.colours.black
    }

    if (transparent) {
      colour = 'transparent'
    }

    return (
      <TopBar
        colour={colour}
        paddingMult={paddingMult}
      >
        {children}
        <ConnectionStatus />
      </TopBar>
    )
  }
}
